export default function FaultsService(faultsRepo, gettextCatalog) {
  'ngInject';

  var faultEnums = {
    priority: {
      Low: {
        label: gettextCatalog.getString('Low'),
        value: 'Low',
      },
      Medium: {
        label: gettextCatalog.getString('Medium'),
        value: 'Medium',
      },
      High: {
        label: gettextCatalog.getString('High'),
        value: 'High',
      },
    },
    clear: {
      Immediately: {
        label: gettextCatalog.getString('Immediately'),
        value: 'Immediately',
      },
      OneDay: {
        label: gettextCatalog.getString('After 24hrs'),
        value: 'OneDay',
      },
    },
    notify: {
      true: {
        label: gettextCatalog.getString('Yes'),
        value: true,
      },
      false: {
        label: gettextCatalog.getString('No'),
        value: false,
      },
    },
  };

  const faultOptionLists = {
    priority: [faultEnums.priority.Low, faultEnums.priority.Medium, faultEnums.priority.High],
    clear: [faultEnums.clear.Immediately, faultEnums.clear.OneDay],
    notify: [faultEnums.notify.true, faultEnums.notify.false],
  };

  function createConfig(name, contacts, equipment, faults, brand) {
    var apiModel = createConfigApiModel(name, contacts, equipment, faults, brand);
    return faultsRepo.postFaultConfiguration(apiModel);
  }

  function getConfigById(configId) {
    return faultsRepo.getFaultConfigurationById(configId).then(function (configResponse) {
      return createConfigViewModel(configResponse);
    });
  }

  function getConfigByName(name) {
    return faultsRepo.getFaultConfigurationByName(name);
  }

  function getAllFaultConfigs() {
    return faultsRepo.getAllFaultConfigurations();
  }

  function updateFaultConfig(id, name, contacts, brand) {
    var config = {
      name,
      contacts: [],
      brand,
    };

    for (var i = 0; i < contacts.length; i++) {
      config.contacts.push(contacts[i].email);
    }
    return faultsRepo.patchFaultConfiguration(id, config);
  }

  function deleteFaultConfig(id) {
    return faultsRepo.deleteFaultConfiguration(id);
  }

  function deleteFault(configId, faultId) {
    return faultsRepo.deleteFault(configId, faultId);
  }

  function postFault(configurationId, newFault) {
    var trigger = createAPITrigger(newFault);

    return faultsRepo.postFault(configurationId, trigger);
  }

  function updateFault(configurationId, faultId, fault) {
    var trigger = createAPITrigger(fault);
    return faultsRepo.updateFault(configurationId, faultId, trigger).then(function (response) {
      return createViewTrigger(response.data);
    });
  }

  function patchFaultConfigEquipment(id, data) {
    return faultsRepo.patchFaultConfigurationEquipment(id, data);
  }

  function createConfigApiModel(name, contacts, equipment, faults, brand) {
    var configuration = {
      name,
      equipment: [],
      contacts: [],
      triggers: [],
      brand,
    };

    for (var i = 0; i < equipment.length; i++) {
      configuration.equipment.push(equipment[i].id);
    }

    for (var i = 0; i < contacts.length; i++) {
      configuration.contacts.push(contacts[i].email);
    }

    if (faults) {
      _.forEach(faults, function (f) {
        var trigger = createAPITrigger(f);
        configuration.triggers.push(trigger);
      });
    }

    return configuration;
  }

  function createAPITrigger(fault) {
    var trigger = {
      type: '',
      code: {},
      priority: '',
      autoClear: '',
      notifyOnReturn: '',
    };

    trigger.type = fault.type;
    trigger.code = fault.code;
    trigger.autoClear = fault.autoClear.value;
    trigger.notifyOnReturn = fault.notifyOnReturn.value;
    trigger.priority = fault.priority.value;
    return trigger;
  }

  function createConfigViewModel(configResponse) {
    var configuration = {
      name: '',
      contacts: [],
      equipment: [],
      triggers: [],
    };

    configuration.name = configResponse.data.name;

    for (var i = 0; i < configResponse.data.contacts.length; i++) {
      configuration.contacts.push(configResponse.data.contacts[i]);
    }

    for (var i = 0; i < configResponse.data.equipment.data.length; i++) {
      configuration.equipment.push(configResponse.data.equipment.data[i].id);
    }

    _.forEach(configResponse.data.triggers.data, function (t) {
      var trigger = createViewTrigger(t);
      configuration.triggers.push(trigger);
    });

    return configuration;
  }

  function createViewTrigger(fault) {
    var trigger = {
      id: '',
      type: '',
      code: {
        spn: '',
        fmi: '',
        source: '',
      },
      priority: '',
      autoClear: '',
      notifyOnReturn: '',
    };

    trigger.id = fault.id;
    trigger.type = fault.type;
    trigger.code.spn = parseInt(fault.code.spn);
    trigger.code.fmi = parseInt(fault.code.fmi);
    trigger.code.source = parseInt(fault.code.source);
    trigger.autoClear = faultEnums.clear[fault.autoClear];
    trigger.notifyOnReturn = faultEnums.notify[fault.notifyOnReturn];
    trigger.priority = faultEnums.priority[fault.priority];
    return trigger;
  }

  function getFaultOptions() {
    var faultOptions = {};
    faultOptions.priority = faultOptionLists.priority;
    faultOptions.clear = faultOptionLists.clear;
    faultOptions.notify = faultOptionLists.notify;
    return faultOptions;
  }

  return {
    createConfig: createConfig,
    createConfigApiModel: createConfigApiModel,
    createAPITrigger: createAPITrigger,
    getConfigById: getConfigById,
    getConfigByName: getConfigByName,
    getAllFaultConfigs: getAllFaultConfigs,
    updateFaultConfig: updateFaultConfig,
    deleteFaultConfig: deleteFaultConfig,
    postFault: postFault,
    deleteFault: deleteFault,
    updateFault: updateFault,
    patchFaultConfigEquipment: patchFaultConfigEquipment,
    getFaultOptions: getFaultOptions,
  };
}
